import SortIcon from "../../../assets/images/sorting.svg";
import styled from "styled-components";
import MoreButton from "../../MoreButton/MoreButton";
import { Input, Popover } from "antd";
import { PencilSimpleSlash } from "@phosphor-icons/react";
import { getFileIcon } from "../../../utils/fileUtils";
import Rename from "../../../assets/images/Rename.svg";
import Merge from "../../../assets/images/merge.svg"
import Delete from "../../../assets/images/Delete.svg";
import Approve from '../../../assets/images/Approve.svg';
import Rework from '../../../assets/images/Rework.svg';
import Share from '../../../assets/images/share.svg';
import InternalShare from '../../../assets/images/internalShare.svg';
import ExternalShare from '../../../assets/images/externalShare.svg';
import AssignIcon from '../../../assets/images/userCircleFrame.svg';
import dayjs from "dayjs";
import React from "react";
import FileProperties from "../../../assets/images/File properties icon.svg"
import SendIcon from "../../../assets/images/send.svg"
import ReviewNotes from "../../../assets/images/review notes.svg";
import ESignImage from "../../../assets/images/E-sign.png";
import DownloadIcon from "../../../assets/images/download.svg";
import AnalysisIcon from "../../../assets/images/sparkle.svg";
import { Box, Tooltip } from "@mui/material";
import { setDocListingPage, setUpdateMeta } from "../../../slice/MatterDetailsSlice";
import { useDispatch } from "react-redux";
import CustomPopover from "../../DocListTooltip";
import { MS_FILE_TYPES, PDF_FILE_TYPES } from "../../../utils/constants";
import { getExtension, getNameWithoutExtension } from "../../TabView/TabViewUtils";
import StatusChip from "../../StatusChip";
import ConfidencePill from "../../ConfidencePill";
import CategoryTag from "../../CategoryTag";
import AIStatusBadge from "../../AIStatusBadge";
import CategorizationBadge from "../../Categorization/CategorizationBadge";
import tokens from "../../../theme/tokens";

const SortIconColumn = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  border-right: 1px solid #dde2e9;
  .sort-icon {
    cursor: pointer;
  }
`;
const SpanText = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
}
`;
const TableTdWrapper = styled.div`
  max-width: 300px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-right: 3px;
`;

const SignatureBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 1px 6px;
  border-radius: 9999px;
  font-size: 10px;
  font-weight: 600;
  font-family: "Manrope", sans-serif;
  white-space: nowrap;
  background: ${(p) =>
    p.$status === "COMPLETED" ? "#dcfce7" :
    p.$status === "PENDING" || p.$status === "IN_PROGRESS" ? "#fef3c7" :
    "#f3f4f6"};
  color: ${(p) =>
    p.$status === "COMPLETED" ? "#166534" :
    p.$status === "PENDING" || p.$status === "IN_PROGRESS" ? "#92400e" :
    "#6b7280"};
  border: 1px solid ${(p) =>
    p.$status === "COMPLETED" ? "#bbf7d0" :
    p.$status === "PENDING" || p.$status === "IN_PROGRESS" ? "#fde68a" :
    "#e5e7eb"};
`;

const FolderMeta = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-family: ${tokens.typography.fontFamily};
  font-size: 12px;
  color: ${tokens.text.tertiary};
  white-space: nowrap;
`;

const ReviewRollup = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px 7px;
  border-radius: 9999px;
  font-size: 11px;
  font-weight: 600;
  color: ${tokens.status.review.fg};
  background: ${tokens.status.review.bg};
  border: 1px solid ${tokens.status.review.border};
  white-space: nowrap;
`;

const CellRow = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
`;

const MutedCell = styled.span`
  color: ${tokens.text.disabled};
  font-family: ${tokens.typography.fontFamily};
  font-size: 13px;
`;

const MatterDetailsTableColumn = ({
  hoveredRowKey = "",
  handleEditAction,
  handleDeleteAction,
  handleSort,
  editingKey,
  editingValue,
  setEditingKey,
  setEditingValue,
  handleSave,
  setTitleName,
  setCurrentPage,
  sort,
  setSort,
  setSortBy,
  sortBy,
  renameEditFlag,
  titleName,
  setOpen,
  setFileProp,
  handleBlur,
  setShowShareModal,
  setShowAssignModal,
  setShowDeleteModal,
  setSelectedDoc,
  setOpenReviewNotes,
  setOpenESignModal,
  openReviewActionModal,
  setShowExternalShareModal,
  setShowSendToVAModal,
  isVaAgencyMatter = false,
  setIsModalOpen,
  setSelectedFile,
  onRunAIAnalysis,
  runningAnalysisDocIds,
  onAIBadgeActivate,
  categorizationFlags,
  onCategorize,
  onExportPdf,
  onOpenPageBuilder,
  onCopy,
  onPasteIntoFolder,
  clipboardCount = 0,
  onDownload,
}
) => {

  const dispatch = useDispatch();

  const getDocumentId = (record) => {
    if (record?.unique_id?.startsWith?.("D")) return record.unique_id.substring(1);
    return record?.id || record?.document_id || null;
  };

  // Function to handle input change

const handleInputChange = (e, id, record) => {
  e.stopPropagation();
  const inputValue = e.target.value;

  const originalName = titleName[id] || "";
  let newFullName = inputValue;

  if (record.type !== "folder") {
    const extension = getExtension(originalName)
    newFullName = `${inputValue}${extension}`;
  }

  setEditingValue(inputValue);
  setTitleName((prev) => ({
    ...prev,
    [id]: newFullName,
  }));
};



  // Function to handle the edit
  const handleRename = (record) => {
    if (record.type === "folder") {
      setEditingKey(record.unique_id);
      setEditingValue(record.name);
    } else if (record.type === "document") {
      setEditingKey(record.unique_id);
      setEditingValue(record.name);
      setTitleName((prev) => ({
        ...prev,
        [record.unique_id]: record.name
      }))
    }
  };

  const onSort = (e) => {
    if (sortBy === e) {
      if (sort === "asc") {
        setSort("desc")
        setSortBy(e)
      } else if (sort === "desc") {
        setSort("asc")
        setSortBy(e)
      } else {
        setSort("asc")
        setSortBy("name")
      }
    } else {
      setSort("asc")
      setSortBy(e)
    }
      setCurrentPage(1);
      dispatch(setDocListingPage(1));
  }



  return [
    {
      title: (
        <SortIconColumn>
          <span>{"NAME"}</span>
          <Box
            className="sort-icon"
            tabIndex={0}
            onClick={() => onSort("name")}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                onSort("name");
              }
            }}
          >
            <img src={SortIcon} alt="Sorting Icon" />
          </Box>
        </SortIconColumn>
      ),
      dataIndex: "name",
      key: "name",
      render: (_, record) => {
        const isRenameEnabled =
          editingKey === record?.unique_id &&
          (
            record?.type === 'folder' ||
            (
              record?.type === 'document' &&
              (
                !record?.is_locked ||
                (record?.is_locked && record?.locked_by === Number(localStorage.getItem("user_id")))
              )
            )
          ); 
        const icon = getFileIcon(record.name, record.type);
        const nameDocId = getDocumentId(record);
        const nameFlags =
          record?.type === "document" && nameDocId && categorizationFlags
            ? categorizationFlags[String(nameDocId)]
            : null;

        return (
          <SpanText>
            {icon}
            <CustomPopover
              name={record?.name}
            >
              <TableTdWrapper 
               onClick={(e) => {
                if (isRenameEnabled) {
                  e.stopPropagation();
                }
              }}
              > {isRenameEnabled ? (
    <div>
      <Input
        style={{ width: record.type === 'folder' ? '100%' : '70%' }}
        value={
      record.type === 'folder'
        ? editingValue
        : getNameWithoutExtension(titleName[record?.unique_id])
    }
        onChange={(e) => handleInputChange(e, record.unique_id,record)}
        onPressEnter={() => handleSave(record)}
        onBlur={() => handleBlur(record)}
        autoFocus
        placeholder="Rename"
        id="my-input-rename-matter-details"
      />
      {getExtension(titleName[record?.unique_id])}
    </div>
  ) : (
    record.name
  )} </TableTdWrapper>
            </CustomPopover>
            {record.is_locked === true && record.locked_by !== Number(localStorage.getItem("user_id")) &&
            PDF_FILE_TYPES.includes(record.file_type)? (
              <Popover
                placement="bottom"
                content={"Document is being edited. View-only mode is enabled"}
              >
                <PencilSimpleSlash size={16} color="#98A6BA" />
              </Popover>
            ) : (
              <></>
            )}
            {record.type === "document" && record.signature_status && (
              <Tooltip title={record.signature_status === "COMPLETED" ? "Signature complete" : "Out for signature"} arrow>
                <SignatureBadge $status={record.signature_status}>
                  {record.signature_status === "COMPLETED" ? "Signed" : "Signing"}
                </SignatureBadge>
              </Tooltip>
            )}
            {record.type === "document" && !record.signature_status && record.has_completed_signature && (
              <Tooltip title="Previously signed" arrow>
                <SignatureBadge $status="COMPLETED">Signed</SignatureBadge>
              </Tooltip>
            )}
            {nameFlags && (nameFlags.hasGoldStandard || nameFlags.hasNegativeExample) && (
              <CategorizationBadge
                goldStandard={!!nameFlags.hasGoldStandard}
                negativeExample={!!nameFlags.hasNegativeExample}
                size="sm"
              />
            )}
          </SpanText>
        );
      }
    },
    {
      title: (
        <SortIconColumn>
          <span>{"ADDED ON"}</span>
          <Box
            tabIndex={0}
            onClick={() => onSort("time_created")}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                onSort("time_created");
              }
            }}
            className="sort-icon">
            <img src={SortIcon} alt="Sorting Icon" />
          </Box>
        </SortIconColumn>
      ),
      dataIndex: "uploaded_at",
      key: "uploaded_at",
      render: (_, record) => <span>{dayjs(record.created_on || record.uploaded_at).format("DD MMM YYYY")}</span>,
    },
    {
      title: (
        <SortIconColumn>
          <span>{"LAST MODIFIED"}</span>
          <Box
            tabIndex={0}
            onClick={() => onSort("last_modified")}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                onSort("last_modified");
              }
            }} className="sort-icon">
            <img src={SortIcon} alt="Sorting Icon" />
          </Box>
        </SortIconColumn>
      ),
      dataIndex: "last_modified",
      key: "last_modified",
      render: (text) => <span>{dayjs(text).format('DD MMM YYYY h:mm A')}</span>,
    },
    {
      title: <span>STATUS</span>,
      dataIndex: "pipeline_status",
      key: "pipeline_status",
      render: (_, record) => {
        if (record?.type === "folder") {
          const count = record?.documents_count ?? record?.document_count;
          const reviewCount = record?.review_count ?? 0;
          if (count == null && !reviewCount) {
            return <MutedCell>—</MutedCell>;
          }
          return (
            <FolderMeta>
              {count != null && <span>{count} {count === 1 ? "doc" : "docs"}</span>}
              {reviewCount > 0 && (
                <ReviewRollup>{reviewCount} review</ReviewRollup>
              )}
            </FolderMeta>
          );
        }

        if (!record?.pipeline_status) {
          return <MutedCell>—</MutedCell>;
        }
        return (
          <StatusChip
            pipelineStatus={record.pipeline_status}
            stageLabel={record?.pipeline_stage_label}
            size="sm"
          />
        );
      },
    },
    {
      title: (
        <SortIconColumn>
          <span>{"CATEGORY"}</span>
          <Box tabIndex={0} className="sort-icon" onClick={() => onSort("category")} onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              onSort("category");
            }
          }}>
            <img src={SortIcon} alt="Sorting Icon" />
          </Box>
        </SortIconColumn>
      ),
      dataIndex: "category",
      key: "category",
      render: (_, record) => {
        if (record?.type === "folder") {
          return <MutedCell>—</MutedCell>;
        }
        const displayCategory = record?.doc_category || record?.category;
        const confidenceValue =
          record?.ai_confidence ?? record?.category_confidence ?? null;
        // Badge → row open + AI panel pre-selection. All variants land
        // on the same destination ("The Brief" / `?ai=analysis`) since
        // the 2026-04-29 rename consolidated matter-mode AI surfaces;
        // the badge's variant arg is intentionally ignored here.
        const handleBadgeActivate =
          typeof onAIBadgeActivate === "function"
            ? () => onAIBadgeActivate(record)
            : undefined;
        return (
          <CellRow>
            <CategoryTag category={displayCategory} />
            <ConfidencePill value={confidenceValue} />
            <AIStatusBadge
              analysisState={record?.analysis_state ?? null}
              onActivate={handleBadgeActivate}
            />
          </CellRow>
        );
      },
    },
    {
      title: <div style={{ display: "none" }}>Action</div>,
      dataIndex: "status",
      key: "status",
      render: (_, record) => {
        const isFolder = record.type === "folder";
        const isLocked = record.is_locked === true && record.locked_by !== Number(localStorage.getItem("user_id"));

        const workflowActions = record?.sharing_context?.workflow_actions || [];
        const showSubmitButton = workflowActions.length === 1 && workflowActions[0] === "submit";
        const showActionButton =
          workflowActions.includes("approve_task")
          || workflowActions.includes("approve_forward")
          || workflowActions.includes("request_rework");
        const submitDisabled = !record?.sharing_context?.submit_enabled;
        const actionDisabled = !record?.sharing_context?.action_enabled;

        const topActions = !isFolder && !isLocked
        ? [
            ...(showSubmitButton
              ? [
                  {
                    label: "Submit",
                    icon: Approve,
                    disabled: submitDisabled,
                    onClick: () => {
                      setFileProp(record);
                      setSelectedDoc(record);
                      dispatch(setUpdateMeta(record));
                      openReviewActionModal("submit");
                    },
                  },
                ]
              : []),
      
            ...(showActionButton
              ? [
                  {
                    label: "Approve",
                    icon: Approve,
                    disabled: actionDisabled,
                    onClick: () => {
                      setFileProp(record);
                      setSelectedDoc(record);
                      dispatch(setUpdateMeta(record));
                      openReviewActionModal("approve");
                    },
                  },
                  {
                    label: "Approve & forward to…",
                    icon: Approve,
                    disabled: actionDisabled,
                    onClick: () => {
                      setFileProp(record);
                      setSelectedDoc(record);
                      dispatch(setUpdateMeta(record));
                      openReviewActionModal("approve_forward");
                    },
                  },
                  {
                    label: "Request Rework",
                    icon: Rework,
                    disabled: actionDisabled,
                    onClick: () => {
                      setFileProp(record);
                      setSelectedDoc(record);
                      dispatch(setUpdateMeta(record));
                      openReviewActionModal("rework");
                    },
                  },
                ]
              : []),
          ]
        : [];
      
        
        const shareActions = !isFolder && !isLocked ? [
          {
            label: "Share",
            icon: Share,
            children: [
              {
                label: "Share Internally",
                icon: InternalShare,
                onClick: () => {
                  setShowShareModal(true);
                  setSelectedDoc(record);
                },
              },
              {
                label: "Share Externally",
                icon: ExternalShare,
                onClick: () => {
                  setShowExternalShareModal(true)
                  setSelectedDoc(record);
                },
              },
            ],
          },
          // Assigning lives next to sharing because it is the same
          // gesture from the partner's point of view -- hand this
          // document to someone -- and this row menu is where they are
          // already working. Until now "Assign task" existed only in
          // the mail-intake pane, so a partner reviewing a matter had
          // no way to reach it (Matthew, 2026-07-26).
          //
          // Both kinds are offered here, matching the mail-intake footer
          // (Matthew, 2026-07-27). They hit the same endpoint and differ
          // only by kind: an assignment reaches the Assignments tab and
          // the alert banner, a task stays in the bell. Both create a
          // Salesforce Task.
          ...(setShowAssignModal
            ? [
                {
                  label: "Create Task",
                  icon: AssignIcon,
                  onClick: () => {
                    setSelectedDoc(record);
                    setShowAssignModal(true);
                  },
                },
              ]
            : []),
        ] : [];
        
        const docIdForAI = record?.unique_id?.startsWith?.("D")
          ? record.unique_id.substring(1)
          : null;
        const rowDocId = getDocumentId(record);
        const rowDocKey = rowDocId ? String(rowDocId) : null;
        const isAnalysisRunningForRow =
          !!docIdForAI && !!runningAnalysisDocIds?.has?.(String(docIdForAI));

        const otherActions = !isFolder && !isLocked ? [
          typeof onCategorize === "function" && !!rowDocKey && {
            label: "Categorize…",
            disabled: !rowDocKey,
            onClick: () => onCategorize(record),
          },
          typeof onRunAIAnalysis === "function" && !!docIdForAI && {
            label: isAnalysisRunningForRow
              ? "AI Analysis in progress…"
              : "Run AI Analysis",
            icon: AnalysisIcon,
            disabled: isAnalysisRunningForRow,
            onClick: () => onRunAIAnalysis(record),
          },
          (PDF_FILE_TYPES.includes(record?.file_type) || MS_FILE_TYPES.includes(record?.file_type))&&{
            label: "Merge Files",
            icon: Merge,
            onClick: () => {
              setSelectedFile(record)
              setIsModalOpen(true)
            },
          },
          // Page-level assembly (drag exhibits into a brief) — PDFs open
          // with their pages browsable; Office files ride along whole.
          typeof onOpenPageBuilder === "function" &&
            (PDF_FILE_TYPES.includes(record?.file_type) || MS_FILE_TYPES.includes(record?.file_type)) && {
              label: "PDF Page Builder",
              icon: Merge,
              onClick: () => onOpenPageBuilder([record]),
            },
          // One-click Office → PDF conversion (server-side, keeps Word
          // formatting via the assembly engine). PDFs don't need it.
          typeof onExportPdf === "function" &&
            MS_FILE_TYPES.includes(record?.file_type) && {
              label: "Export as PDF",
              icon: FileProperties,
              onClick: () => onExportPdf(record),
            },
          {
            label: "File Properties",
            icon: FileProperties,
            onClick: () => {
              setFileProp(record);
              setSelectedDoc(record);
              dispatch(setUpdateMeta(record));
              setOpen(true);
            },
          },
         record.is_review_notes_available && {
            label: "Review Notes",
            icon: ReviewNotes,
            onClick: () => {
              setFileProp(record);
              setSelectedDoc(record);
              setOpenReviewNotes(true);
            },
          },
          !record.signature_status && {
            label: "Send for E-Signature",
            icon: ESignImage,
            onClick: () => {
              setFileProp(record);
              setSelectedDoc(record);
              setOpenESignModal(true);
            },
          },
          isVaAgencyMatter && {
            label: "Submit to VA",
            icon: SendIcon,
            onClick: () => {
              setFileProp(record);
              setSelectedDoc(record);
              setShowSendToVAModal(true);
            },
          },
          
        ].filter(Boolean) : [];
        
        const commonActions = [
          !isFolder && typeof onDownload === "function" && {
            label: "Download",
            icon: DownloadIcon,
            onClick: () => onDownload(record),
          },
          !isFolder && typeof onCopy === "function" && {
            label: "Copy",
            onClick: () => onCopy(record),
          },
          isFolder &&
            clipboardCount > 0 &&
            typeof onPasteIntoFolder === "function" && {
              label: `Paste ${clipboardCount} file${
                clipboardCount === 1 ? "" : "s"
              }`,
              onClick: () => onPasteIntoFolder(record),
            },
          {
            label: "Rename",
            icon: Rename,
            onClick: () => handleRename(record),
          },
          {
            label: "Delete",
            icon: Delete,
            onClick: () => {
              setShowDeleteModal(true);
              setSelectedDoc(record);
            },
          },
        ].filter(Boolean);

        const menuOptions = [
          ...topActions,
          ...shareActions,
          ...commonActions,
          ...otherActions,
        ];
        
        const content =
          !isFolder && isLocked && !MS_FILE_TYPES.includes(record?.file_type) ? ( //
            <></>
          ) : (
            <MoreButton menuOptions={menuOptions} />
          );

        return <>{content}</>;
      }
    },
  ];
};

export default MatterDetailsTableColumn;